interface CheckBoxProps {
  title: string;
  count?: number;
  onChange?: (isChecked: boolean) => void;
  checked?: boolean;
  defaultChecked?: boolean;
}

export default function Checkbox({
  title,
  count,
  onChange,
  checked,
  defaultChecked,
}: CheckBoxProps) {
  return (
    <div className="d-flex align-items-center py-2">
      <label className="text-95 mb-0">
        <input
          type="checkbox"
          className="mr-2 bgc-blue brc-h-blue-m1"
          onChange={(e) => onChange && onChange(e.target.checked)}
          checked={checked}
          defaultChecked={defaultChecked}
        />
        {title}
      </label>

      {count && (
        <span className="badge badge-pill bgc-blue-l3 text-blue-d2 ml-auto">
          {count}
        </span>
      )}
    </div>
  );
}
